import moment from 'moment'
import ScheduleEventService from '@/services/api/ScheduleEventService'
import {toastedNotify} from '../../../util/Util'
import {notifyErrors} from '../../../util/VueUtils'
import { isString, orderBy, uniqBy } from 'lodash'


export default {
  namespaced: true,
  state: {
    selectedAuthor: null,
    calendarOptions: [

    ],
    calendarTypes: [

    ],
    selectedCalendars: [],
    authors: [],
    inputFiles: []
  },
  getters: {
    authors: state => state.authors,
    inputFiles: state => state.inputFiles
  },
  mutations: {
    SET_INPUT_FILES(state, val) {
      state.inputFiles = val
    },
    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },
    SET_CALENDAR_TYPES(state, val) {
      state.calendarTypes = val
    },
    SET_AUTHOR(state, val) {
      state.selectedAuthor = val
    },
    ADD_AUTHORS(state, val) {
      state.authors = state.authors.concat(val)
      state.authors = uniqBy(state.authors, 'email')

      state.authors = orderBy(state.authors, 'text', 'desc')
    },
  },
  actions: {
    setInputFiles({commit}, files) {
      commit('SET_INPUT_FILES', files)
    },
    setAuthor({commit}, authorId) {
      commit('SET_AUTHOR', authorId)
    },
    fetchEvents(ctx, { calendars, filters = {} }) {
      const service = ScheduleEventService.build(null)
      return new Promise((resolve, reject) => {

        // Incluir o autor selecionado nos filtros se disponível
        const finalFilters = {
          ...filters,
          author: ctx.state.selectedAuthor || filters.author
        }

        service.findAllScheduleEvents(calendars.join(','), finalFilters)
        .then(response => {

          let events = []
          response.forEach((scheduleEvent, i) => {

            scheduleEvent.schedule_suggestions.forEach(scheduleSuggestion => {

              scheduleEvent.schedule_suggestion_guests.forEach(element => {
                const type = {
                  null: 'external_entity',
                  'App\\Models\\User': 'user',
                  'App\\Models\\Corp\\LegalEntity': 'legal_entity',
                  'App\\Models\\Corp\\OrganizationalUnit': 'organizational_unit',
                }[element.entity_type]

                element.type = type
              });

              events.push({
                id: +scheduleSuggestion.id,
                title: scheduleEvent.title,
                description: scheduleEvent.description,
                // url: scheduleEvent.url ? scheduleEvent.url : null,
                // Use ISO 8601 with timezone to ensure correct parsing in timeGrid views
                start: moment(scheduleSuggestion.start_at).format('YYYY-MM-DD[T]HH:mm:ssZ'),
                end: moment(scheduleSuggestion.finish_at).format('YYYY-MM-DD[T]HH:mm:ssZ'),
                start_formmated: scheduleSuggestion.start_at_formatted,
                end_formmated: scheduleSuggestion.finish_at_formatted,
                allDay: false,
                organizationalUnitsList: [],
                extendedProps: {
                  calendar: scheduleEvent.calendar_type_id,
                  repeat: scheduleEvent.repeat,
                  repeat_until: scheduleEvent.repeat_until,
                  guests: scheduleEvent.schedule_suggestion_guests,
                  location: '',
                  description: scheduleEvent.description,
                  suggestionDateList: scheduleEvent.schedule_suggestions && scheduleEvent.schedule_suggestions.length >= 0 ? scheduleEvent.schedule_suggestions : [],
                  scheduleEventId: scheduleEvent.id,
                  eventUrl: scheduleEvent.url ? scheduleEvent.url : null,
                  reminders: scheduleEvent.reminders,
                  invited: scheduleEvent.invited,
                  author_name: scheduleEvent.author_name,
                  author_email: scheduleEvent.author_email,
                },
              })

            })
          })

          resolve(events)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    addEvent(ctx, { event }) {
      const service = ScheduleEventService.build(null)
      return new Promise((resolve, reject) => {
        const params = {
          title: event.title,
          url: event.extendedProps.eventUrl,
          description: event.extendedProps.description,
          calendar_type_id: event.extendedProps.calendar,
          repeat: event.extendedProps.repeat,
          repeat_until: moment(event.extendedProps.repeat_until, 'DD/MM/YYYY HH:mm').format('MM/DD/YYYY HH:mm'),
          schedule_suggestions: event.extendedProps.suggestionDateList,
          guests: event.extendedProps.guests,
          reminders: event.extendedProps.reminders
        }

        service.create(params)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))

      })
    },
    updateEvent(ctx, { event }) {
      const service = ScheduleEventService.build(null)

      let until = event.extendedProps.repeat_until

      if (isString(until) && until.includes('Z')) {
        until = moment(event.extendedProps.repeat_until).format('MM/DD/YYYY HH:mm')
      } else if(isString(until)) {
        until = moment(event.extendedProps.repeat_until, 'DD/MM/YYYY HH:mm').format('MM/DD/YYYY HH:mm')
      } else {
        until = null
      }


      return new Promise((resolve, reject) => {
        const params = {
          id: event.extendedProps.scheduleEventId,
          title: event.title,
          url: event.url,
          description: event.extendedProps.description,
          calendar_type_id: event.extendedProps.calendar,
          repeat: event.extendedProps.repeat,
          repeat_until: until || null,
          schedule_suggestions: event.extendedProps.suggestionDateList,
          guests: event.extendedProps.guests,
          start_at: event.start,
          finish_at: event.end,
          reminders: event.extendedProps.reminders
        }

        service.update(params)
          .then(response => {
            response.schedule
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, { id, reason }) {
      return new Promise((resolve, reject) => {

        const service = ScheduleEventService.build(null)
        service.delete(id, {
          reason: reason || null
        })
          .then(response => {
            response.schedule
            resolve(response)
          })
          .catch(error => {
            notifyErrors({notify: toastedNotify}, error)
            reject(error)
          })

      })
    },
  },
}
